import styled from 'styled-components'

export const Row = styled.div`
  margin-bottom: 1.5rem;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 10px;

  @media (max-width: 700px) {
    flex-direction: column;
  }
`
export const Col = styled.div`
  display: flex;
	flex-direction: column;
	gap: 10px;
`

export const Label = styled.label`
  margin-bottom: 0.375rem;
  font-weight: 500;
  display: inline-block;
`

export const Input = styled.div`
  width: 100%;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
`
